import { myFetchRequestApi } from '@/http/my-fetch';
import type { FlightQueryParamAo, FlightListResponseAo, FlightFraeRuleAo } from '@/apis/flights/model/index';

enum Api {
	orderService = 'orderService',
	searchService = 'searchService',
	queryFlightListUrl = '/PolarisQuery/query',
	priceVerifyUrl = 'PolarisOrder/price/verify',
	fareRuleUrl = '/PolarisOrder/fare/rule/text',
	postFareRuleUrl = '/PolarisOrder/fare/rule/search'
}

// 查询航班列表
export const queryFlightListApi = async (params: FlightQueryParamAo) => {
	const res = await myFetchRequestApi<FlightListResponseAo>(
		Api.searchService,
		true,
		Api.queryFlightListUrl,
		{
			method: 'POST',
			params
		});
	return res.data;
};
// 航班验价接口
export const priceVerifyApi = async (params: { cid: string; data: string; returnSearch?: boolean; otaReferenceId?: string; }) => {
	const res = await myFetchRequestApi<FlightFraeRuleAo>(
		Api.orderService,
		true,
		Api.priceVerifyUrl,
		{
			method: 'POST',
			params
		});
	return res;
};
// 查询航班退改及行李额信息
export const queryFlightFareRule = async (params: { sessionId: string; }) => {
	const res = await myFetchRequestApi<FlightFraeRuleAo>(
		Api.orderService,
		true,
		Api.fareRuleUrl,
		{
			method: 'GET',
			params
		});
	return res.data;
};
// 查询航班退改及行李额信息
export const queryFlightListFareRule = async (params: { cid: string, data: string; }) => {
	const res = await myFetchRequestApi<FlightFraeRuleAo>(
		Api.orderService,
		true,
		Api.postFareRuleUrl,
		{
			method: 'POST',
			params
		});
	return res.data;
};
